export { DispensariesController as DispensariesPage } from './dispensaries.controller';
